<template>
  <aside class="executive-summary-page">
    <DocumentPageTitle
      :word-count="totalWords"
      :word-limit="wordLimit"
      title="Executive Summary"
    />

    <TextEditorInput
      v-for="storeItem in storeItems"
      :id="storeItem.id"
      :key="storeItem.id"
      v-model="planContentKey[storeItem.storeKey]"
      :label="storeItem.label"
      :word-limit="wordLimit"
      :total-word-count="totalWords"
      @update:word-count="handleWordCountUpdate"
    />
  </aside>
</template>

<script setup>
import { usePlanStore } from '@/store';
import { DocumentPageTitle } from '@/components/plan-document/components';
import { TextEditorInput } from '@/components/form-inputs';
import { useString, useTinyMCEWordCount } from '@/composables';
import { computed } from 'vue';

const planStore = usePlanStore();
const string = useString();

const wordLimit = 3000;

const planContentKey = computed(() => {
  return planStore.content?.executiveSummary || null;
});

const storeItems = [
  { storeKey: 'whoWeAre', label: 'Who are we?' },
  { storeKey: 'issues', label: 'What are the issues we are facing?' },
  { storeKey: 'opportunitiesOffered', label: 'What opportunities do we offer?' },
  { storeKey: 'serviceDeliveryImprovement', label: 'What are we doing to improve service delivery over the next 5 years?' },
  { storeKey: 'councilPriorities', label: 'Priorities of council' },
  { storeKey: 'expectations', label: 'What can you expect from us?' },
  { storeKey: 'progressMeasurement', label: 'How will our progress be measured?' },
  { storeKey: 'howWasIdpDeveloped', label: 'How was this IDP developed?' },
].map(storeItem => ({ ...storeItem, id: string.sluggify(storeItem.label) }));

const storeItemIds = storeItems.map(storeItem => storeItem.id);

const {
  totalWords,
  updateCount,
} = useTinyMCEWordCount(wordLimit, storeItemIds);

const handleWordCountUpdate = ({ id, count }) => {
  updateCount(id, count);
};
</script>
